import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import ArrowIcon from "../../images/next-prev-3.svg"

const BlockContentTestimonial = ({ data, context, ...props }) => {
  const testimonials = data?.relationships?.items
  const stripHtmlTags = (html) => {
    // Create a new DOM element and set its innerHTML to the string containing HTML
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || ""; // Extract the textContent without HTML tags
  };
  
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ItemList",
      "itemListElement": testimonials?.map((testimonial, index) => ({
        "@type": "Review",
        "position": index + 1,
        "itemReviewed": {
          "@type": "SoftwareApplication",
          "name": "Sightfull",
          "applicationCategory": "BusinessApplication",
          "operatingSystem" : "Cloud"
        },
        "author": {
          "@type": "Person",
          "name": testimonial.label,
        },
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": 5,
          "bestRating": "5",
          "worstRating": "1",
        },
        "reviewBody": stripHtmlTags(testimonial.descriptionHtml.processed),
      })),
    });
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, [testimonials]);

  const [swiper, setSwiper] = useState();

  const handleNext = () => {
    const index =
      swiper.activeIndex + 1 < swiper.slides.length
        ? swiper.activeIndex + 1
        : 0;
    swiper.slideTo(index, 500);
  };

  const handlePrev = () => {
    const index =
      swiper.activeIndex - 1 >= 0
        ? swiper.activeIndex - 1
        : swiper.slides.length - 1;
    swiper.slideTo(index, 500);
  };

  return (
    <div className="">
     
      <Swiper
        //modules={isMobile ? [Pagination, Navigation] : [Navigation]}
        //className={isMobile ? ' ' : "  lg:w-full swiper-on-front-page"}
        //spaceBetween={isMobile ? 10 : 50}
        slidesPerView={1}
        //navigation={isMobile ? false : true}
        //pagination={isMobile ? { clickable: true } : {}}
        //onSlideChange={(swiper) => { setActiveSlide(swiper.activeIndex) }}
        onSwiper={(swiper) => setSwiper(swiper)}
      >
        {data?.relationships.items.map((props, i) => (
          <SwiperSlide className=" " key={i}>
            <Card
              {...props}
              /*className={classNameCard}*/ 
              onNext={handleNext}
              onPrev={handlePrev}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

const Card = ({
  label,
  slug,
  descriptionHtml,
  image,
  relationships,
  company,
  logo,
  className = "",

  onNext,
  onPrev,
  ...props
}) => {
  //console.log(descriptionHtml)

  return (
    <div
      className={
        "mx-auto space-y-8 bg-[#F9F8F7] w-full px-6 md:px-[60px] py-[60px] rounded-[20px] " +
        className
      }
    >
      <img
        src={relationships.logo?.uri?.url}
        //height={logo.height * 0.75}
        width={120}
        alt={logo.alt}
        className="block mx-auto"
      />


      <div
        className="text-lg --text-dark --testimonial-desc text-center max-w-[780px] mx-auto text-[#3D434C] tracking-[-0.01em] leading-[28.8px] "
        dangerouslySetInnerHTML={{ __html: descriptionHtml.processed }}
      />

      <div className="flex flex-row  justify-center gap-[42px]">
        <button onClick={onPrev} className="p-1 font-medium text-lg " aria-label="prev"><img src={ArrowIcon} alt="" className="rotate-180" /></button>
        <div>
          <img src={relationships.image.uri.url} alt={image.alt} className=""/>
        </div>
        <button onClick={onNext} className="p-1 font-medium text-lg" aria-label="next"><img src={ArrowIcon} alt="" className="" /></button>
      </div>
  

      <div className="flex flex-col  items-center  justify-center">
        <div className="text-base leading-[19.2px] tracking-[-0.01em]	">
          <div className="font-semibold">{label}</div>
        </div>
        {/* <div className="text-sm leading-6	-mt-1 ml-4">
          <div>{slug}</div>
        </div> */}
      </div>
    </div>
  );
};

export default BlockContentTestimonial;
